import { ReactElement, useEffect, useState } from "react";
import clsx from "clsx";
import {
  createTheme,
  Grid,
  makeStyles,
  ThemeProvider,
} from "@material-ui/core";
import { DropzoneArea } from "material-ui-dropzone";

const theme = createTheme({
  overrides: {
    MuiDropzoneArea: {
      root: {
        display: "flex",
        justifyContent: "center",
      },
      textContainer: {
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      },
      text: {
        color: "#757575",
        fontSize: "1rem",
        textTransform: "uppercase",
      },
      icon: {
        color: "#757575",
        fontSize: "0.8rem",
        order: -1,
      },
    },
    MuiDropzonePreviewList: {
      root: {
        border: "dashed",
        borderRadius: 4,
        borderColor: "rgba(0, 0, 0, 0.12)",
        backgroundColor: "#fff",
        width: "100%",
        margin: 0,
      },
      imageContainer: {
        maxWidth: "fit-content",
      },
      image: {
        width: "auto",
        height: "auto",
        maxHeight: 200,
      },
    },
  } as any,
});

const useStyles = makeStyles({
  filled: { display: "none !important" },
  disabled: {
    cursor: "unset !important",
    "& button": { display: "none !important" },
  },
});

interface IProps {
  className?: string;
  label?: string;
  Icon?: ReactElement;
  file?: File;
  acceptedFiles?: string[];
  onChange?: (files: File[]) => void;
  disabled?: boolean;
}

const DropzoneField = ({
  className,
  label,
  Icon,
  file,
  acceptedFiles,
  onChange,
  disabled = false,
}: IProps) => {
  label = label || "Arraste e solte um arquivo aqui";

  const classes = useStyles();
  const [initialFile, setInitialFile] = useState(file);
  const [hasFile, setHasFile] = useState(Boolean(file));

  useEffect(() => {
    setInitialFile(file);
    setHasFile(Boolean(file));
  }, [file]);

  const handleChangeFile = (files: File[]) => {
    setHasFile(Boolean(files.length));
    if (onChange) onChange(files);
  };

  return (
    <Grid item xs className={className}>
      <ThemeProvider theme={theme}>
        <DropzoneArea
          dropzoneClass={clsx({
            [classes.filled]: hasFile,
            [classes.disabled]: disabled,
          })}
          dropzoneText={label}
          Icon={Icon}
          initialFiles={initialFile ? [initialFile] : []}
          filesLimit={1}
          showPreviews={true}
          showPreviewsInDropzone={false}
          showAlerts={["error"]}
          acceptedFiles={acceptedFiles}
          onChange={handleChangeFile}
          dropzoneProps={{
            disabled,
          }}
          previewText={""}
          previewGridProps={{
            container: {
              justifyContent: "center",
            },
            item: {
              xs: 12,
            },
          }}
        />
      </ThemeProvider>
    </Grid>
  );
};

export default DropzoneField;
